import { useFilters, usePagination, useSortBy, useTable } from 'react-table-v7';

const useCustomTable = (columns, list = []) => {
  const tableInstance = useTable(
    {
      columns,
      data: list,
      manualPagination: true,
    },
    useFilters,
    useSortBy,
    usePagination,
  );

  return {
    ...tableInstance,
  };
};
export default useCustomTable;
